import { FormikInputControlProps } from 'app/components/formik-controls';
import { useState, FocusEvent, ChangeEvent } from 'react';
import { FormGroup } from 'app/components/form';
import { styled } from 'styled-components';
import { useFormikContext, useField } from 'formik';
import { Classes } from '@blueprintjs/core';
import { handleMaxDecimalPlaces } from 'app/helpers';
import { StyledInputGroup } from '../form/input/Input';
import { FieldError } from './field-error';

const StyledUnlockableInput = styled.span`
  ${StyledInputGroup} {
    pointer-events: none;
    .${Classes.INPUT} {
      cursor: pointer;
    }
  }
`;

export const FormikUnlockableInputControl = (props: FormikInputControlProps) => {
  const context = useFormikContext<Record<string, any>>();
  const {
    name,
    label,
    required,
    helperText,
    hideValidationErrors,
    className,
    disabled,
    maxDecimalPlaces,
    ...inputGroupProps
  } = props;
  const fieldError = context.errors[name];
  const [field, meta, helper] = useField(name);

  const [isLocked, setIsLocked] = useState(true);
  const handleUnlock = () => {
    if (!disabled) {
      setIsLocked(false);
    }
  };
  const handleOnBlur = (e: FocusEvent<HTMLInputElement>) => {
    field.onBlur(e);
    inputGroupProps?.onBlur?.(e);
    if (!meta.error) {
      setIsLocked(true);
    }
  };

  const handleOnChange = (e: ChangeEvent<HTMLInputElement>) => {
    field.onChange(e);
    props?.onChange?.(e);
    if (maxDecimalPlaces && props.type === 'number') {
      helper.setValue(handleMaxDecimalPlaces(e.target.value, maxDecimalPlaces));
    }
  };

  return (
    <FormGroup label={label} labelFor={name} helperText={helperText} $isRequired={required}>
      {isLocked && (
        <StyledUnlockableInput onClick={handleUnlock}>
          <StyledInputGroup {...field} {...inputGroupProps} id={name} disabled />
        </StyledUnlockableInput>
      )}
      {!isLocked && (
        <StyledInputGroup
          {...field}
          {...inputGroupProps}
          id={name}
          $isError={!hideValidationErrors && meta.touched && !!fieldError}
          onBlur={handleOnBlur}
          onChange={handleOnChange}
        />
      )}
      {!hideValidationErrors && meta.touched && <FieldError name={name} />}
    </FormGroup>
  );
};
